/**
 * Created by Ning Jiang on 9/14/2017.
 */

require("pixi-particles");

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Emitter} from "pixi-particles";

export class BackgroundParticles extends BaseView {

    private _defaultSpeed:any = {
        "start" : 230,
        "end" : 330,
        "minimumSpeedMultiplier" : 1.5
    };

    private _defaultConfig:any = {
        "alpha" : {
            "start" : 0.5,
            "end" : 0.4
        },
        "scale" : {
            "start" : 0.8,
            "end" : 1.0,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 230,
            "end" : 330,
            "minimumSpeedMultiplier" : 1.5
        },
        "acceleration" : {
            "x" : 0,
            "y" : -80
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 270
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 100,
            "max" : 500
        },
        "lifetime" : {
            "min" : 4,
            "max" : 4
        },
        "blendMode" : "add",
        "frequency" : 0.2,
        "emitterLifetime" : -1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : GameConfig.instance.GAME_HEIGHT,
            "w" : GameConfig.instance.GAME_WIDTH,
            "h" : 1
        }
    };

    private _emitter:Emitter;
    private _target:PIXI.Container;
    private _targetLayer:ScalableLayer;
    private _isPlaying:boolean = false;

    constructor() {
        super(ResourcesGroupName.INTRO);
    }

    public play(speedFactor:number, target?:PIXI.Container, targetLayer?:ScalableLayer):void {
        this._isPlaying = true; // it never set false once started.

        this._defaultConfig.speed.start = this._defaultSpeed.start * speedFactor;
        this._defaultConfig.speed.end = this._defaultSpeed.end * speedFactor;

        if(target) {
            this._target = target;
            this._target.addChild(this);
        }
        if(targetLayer) {
            this._targetLayer = targetLayer;
        }

        this._isResizeDirty = true;
        this.onResize(this._resizeData);
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;

        if(!this._resizeData || !this._isPlaying || !this._targetLayer) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;

        if(this._emitter) {
            ParticlesManager.removeEmitter(this._emitter);
        }

        const screenWidth:number = Math.round(resizeData.width / this._targetLayer.scale.x);
        const screenHeight:number = Math.round(resizeData.height / this._targetLayer.scale.y);

        this._defaultConfig.spawnRect.y = screenHeight;
        this._defaultConfig.spawnRect.w = Math.min(screenWidth, GameConfig.instance.GAME_WIDTH);

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._defaultConfig.lifetime.min = this._defaultConfig.lifetime.max = 5;
        } else {
            this._defaultConfig.lifetime.min = this._defaultConfig.lifetime.max = 4;
        }

        this._emitter = new Emitter(this, GameResources.getTextures("particle"), this._defaultConfig);
        ParticlesManager.addEmitter(this._emitter, true);
    }
}